import { Component, ViewChild, OnInit,  Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormControl, UntypedFormArray, Validators } from '@angular/forms';
import { PagesService } from '../../../services/pages.service';
import { compare } from 'fast-json-patch';
import {google} from 'google-translate';



declare function googleTranslateElementInit(): any;


@Component({
  selector: 'app-wizardpage-step1-general',
  templateUrl: './wizardpage-step1.component.html',
  providers: [PagesService],
  styleUrls: ['./wizardpage-step1.component.scss']
})
export class WizardpageStep1GeneralComponent implements OnInit {

  initForm: any;
  isfetching: boolean;
  isfetchingBranches: boolean;

  // tslint:disable-next-line:max-line-length
   @Output() continueevnt: EventEmitter<any> = new EventEmitter<any>(); // send event out to parent through emitter, then pass in event through function
   @Output() wizardeevnt: EventEmitter<any> = new EventEmitter<any>();
   @Output() pagecountevnt: EventEmitter<number> = new EventEmitter<number>();

  isSubmitted = false;
  officesearchdisabled = true;

  howheartypes = [
    {name: 'MyCNAjobs.com', value: 1},
    {name: 'Zip Recruiter', value: 2},
    {name: 'Case Manager', value: 3},
    {name: 'Employee', value: 4},
    {name: 'Premier Website', value: 5},
    {name: 'Word of Mouth', value: 6 },
    {name: 'Indeed', value: 7},
    //md changes
    {name: 'We are family', value: 14},//8 Other
    {name: 'Social Media', value: 15},//9 FaceBook
    {name: 'TV Ad', value: 16},//10 Instagram
  ];

  positions = [
    {name: 'HHA - Home Health Aide', value: 1},
    {name: 'CNA - Certified Nursing Assistant', value: 2},
    {name: 'PCA - Personal Care Aide', value: 3},
    {name: 'Companion', value: 4},
    {name: 'RN - Registered Nurse', value: 5},
    {name: 'LPN - Licensed Practical Nurse', value: 6},
    {name: 'NP - Nurse Practicioner', value: 7},
    {name: 'Home Health Aide Training', value: 8},
    {name: 'HCA- Home Care Aides',  value: 9}];

    branchList = [
      {name: 'NY—NYC (Brooklyn/Kings County) 3561', value: 3561},
      { name: 'NY—NYC (Manhattan/New York County) 3562', value: 3562},
      { name: 'NY—NYC (Queens County) 3563', value: 3563},
      { name: 'NC—Asheville (Buncombe County) 61', value: 61},
      // { name: 'Rockland County, NY', value: 53},
      { name: 'NY—NYC (Bronx County) 2', value: 2},
      { name: 'NC—Burlington (Alamance & Guilford Counties) 62', value: 62},
      { name: 'NC—Charlotte (Mecklenburg County) 46', value: 46},
      { name: 'NC—Conover (Catawba County) 60', value: 60},
      { name: 'MA—Fall River (Bristol County) 27', value: 27},
      { name: 'NJ—Fort Lee (Bergen County) 23', value: 23},
      // { name: 'Hershey, PA (19)', value: 19},
      { name: 'NC—High Point (Guilford County and Davidson, Forsyth & Randolph Counties) 47', value: 47},
      { name: 'IL—Joliet (Will County) 82', value: 82},
      { name: 'FL—Naples (Collier County) 45', value: 45},
      { name: 'MA—Northborough (Worcester County) 26', value: 26},
      //{ name: 'IL—Oak Park (Cook County) 80', value: 80},
      { name: 'IL—Forest Park (Cook County) 80', value: 80},//md add
      { name: 'NY—Premier Asian (NYC, Long Island, Westchester) 58', value: 58},
      { name: 'NY—Premier Russian (NYC, Long Island, Westchester) 30', value: 30},
      // { name: 'Riverhead, NY', value: 125},
      //{ name: 'NY—Ronkonkoma (Suffolk County) 15', value: 15}, //md add
      { name: 'NY—Deer Park (Suffolk County) 15', value: 15},
      // { name: 'Stamford, CT', value: 34},
      { name: 'NY—Staten Island (Richmond County) 52', value: 52},
      { name: 'NJ—Union (Union County) 39', value: 39},
      { name: 'NY—Wappingers Falls (Dutchess County) 16', value: 16},
      { name: 'NJ—West Orange (Essex County) 38', value: 38},
      { name: 'NY—Westbury (Nassau County) 204', value: 204},
      { name: 'CT—Westport (Fairfield County) 37', value: 37},
      { name: 'NY—White Plains (Westchester County) 11', value: 11},
      { name: 'FL—Palm Beach Gardens (Palm Beach County) 145', value: 145}
      //{ name: 'Yonkers PHC, NY', value: 90}
];

planguage = [
    { name: 'English', value: 1},
    { name: 'Spanish', value: 2},
    { name: 'Chinese (Simplified)', value: 3},
    { name: 'Chinese (Traditional)', value: 4},
    { name: 'Korean', value: 5},
    { name: 'Russian', value: 6},
    { name: 'Portuguese', value: 7},
    { name: 'Haitian Creole', value: 8},
    { name: 'Other', value: 9}
];

officeList: UntypedFormGroup;
branchchecked: boolean;

constructor(private pagesService: PagesService,  private fb: UntypedFormBuilder) {
    this.officeList = this.fb.group({
      blist: [this.fb.array([])],
    });
}


@Input() regForm: UntypedFormGroup;

ngOnInit(): void {
  this.initForm = this.regForm.value;
  this.isfetching = false;

  // googleTranslateElementInit();

  this.toggleOfficeSearch(this.regForm.get('priLanguage').value);
}

Selection(valchecked: boolean, ocode: string) {
  // tslint:disable-next-line:radix
  const branchID = this.regForm.get('branchId').value;
  this.regForm.patchValue({
    // tslint:disable-next-line:radix
    branchId: parseInt(ocode)});
    this.getWizardStepsChild();
    this.officeList.controls.blist.value.value.forEach(x => {
      if (x.OfficeCode === ocode && valchecked) {
          x.OChecked = true;
        } else {
          x.OChecked = false;
        }
  });
 }


  somethingChanged($event) {

    const lang = this.regForm.get('priLanguage').value;
    this.isfetchingBranches = true;

    this.pagesService.getNearestOffice($event, lang).subscribe((genVal) => {

      this.officeList.controls.blist.value.clear();

      const control = this.officeList.controls.blist.value as UntypedFormArray;

      genVal.forEach((x) => {
        control.push(
          this.fb.group({
            OfficeCode: x.OfficeCode,
            OfficeName: x.OfficeName,
            Address: x.Address,
            Distance: x.Distance,
            OChecked: false
          })
        );
      });

      this.isfetchingBranches = false;

     });

  }


  getWizardStepsChild() {

      const branchID = this.regForm.get('branchId').value;
      const Position = this.regForm.get('position').value;
      const Id = this.regForm.get('Id').value;



      const sendData = {
                  position : Position === null ? 0 : Position,
                  branchId: branchID === null ? 0 : branchID,
                  appId: Id
                  };

      if (branchID === 'Please Choose...' || Position === 'Please Choose...') {
        return false;
                 }

      this.wizardeevnt.emit(sendData);

      return true;
  }


  toggleOfficeSearch(event: any) {



    const selectedvalue = event === null || event === '' ? 0 : event > 0 ? event : event.currentTarget.value.split(':')[1].trim();

    if (selectedvalue === 0 || selectedvalue === 'null')  {

     this.officesearchdisabled = true;
    } else {this.officesearchdisabled = false; }


  }



  step1Submitted(postValue: UntypedFormGroup) {

    const documentA = this.initForm;
    const documentB = postValue.value;


    const jsonpatchobject = compare(documentA, documentB);

    this.regForm.get('position').markAsTouched();
    this.regForm.get('position').updateValueAndValidity();
    this.regForm.get('firstName').markAsTouched();
    this.regForm.get('firstName').updateValueAndValidity();
    this.regForm.get('lastName').markAsTouched();
    this.regForm.get('lastName').updateValueAndValidity();
    this.regForm.get('last4Ss').markAsTouched();
    this.regForm.get('last4Ss').updateValueAndValidity();
    this.regForm.get('primaryPhone').markAsTouched();
    this.regForm.get('primaryPhone').updateValueAndValidity();
    this.regForm.get('eMail').markAsTouched();
    this.regForm.get('eMail').updateValueAndValidity();
    this.regForm.get('howDidYouHearId').markAsTouched();
    this.regForm.get('howDidYouHearId').updateValueAndValidity();
    this.regForm.get('branchId').markAsTouched();
    this.regForm.get('branchId').updateValueAndValidity();
    this.regForm.get('priLanguage').markAsTouched();
    this.regForm.get('priLanguage').updateValueAndValidity();

    this.isSubmitted = true;
    if (!this.regForm.valid) {
      return false;
    } else {

    this.isfetching = true;
// the is the event property of the template emitting the validation value to the parent component
    this.continueevnt.emit(jsonpatchobject);
    this.pagecountevnt.emit(1);

    return true;

   }
  }

  isFetching(e) {
  this.isfetching = e; }
}
